import React from 'react';

import { usePriceVisibility } from 'hooks/usePriceVisibility';

/**
 * Affiche un prix RATTACHÉ À UN PRODUIT, ou rien si ce client ne doit pas le voir.
 *
 * À utiliser partout où un montant se rapporte à un produit précis : prix unitaire, prix au kilo,
 * total d'une ligne de panier. Les montants qui n'appartiennent à aucun produit — sous-total, TVA,
 * livraison, budget, minimum de commande — ne passent PAS par ici : ils restent toujours affichés.
 *
 * Le masquage est purement un affichage ; le prix réel continue d'alimenter le panier, la commande et
 * la facture.
 */
export const PriceIfVisible = ({
    productId,
    children,
}: {
    productId: string | null | undefined;
    children: React.ReactNode;
}) => {
    const { isPriceVisible } = usePriceVisibility();

    if (!isPriceVisible(productId)) {
        return null;
    }

    return <>{children}</>;
};
